import React, { useState, useEffect, useRef } from 'react';
import { useSignalR } from '../SignalRContext/signalRContext';
import Send from '../../assets/images/send-message.png';
import MinimizeIcon from '../../assets/images/remove.svg';
import CloseIcon from '../../assets/images/close_png.png';
import MaximiseIcon from '../../assets/images/max_png.png';
import check from '../../assets/images/check.png';
import checkfill from '../../assets/images/check-fill.png';
import notification from '../../assets/images/notification.png';
import attachment from '../../assets/images/attachment.svg';
import mike from '../../assets/images/mike.svg';
import expand from '../../assets/images/expand.svg';
import collapse_chat from '../../assets/images/collapse.svg';
import sms from '../../assets/images/sms.png';
import chat from '../../assets/images/chat_support.png';
import email from '../../assets/images/mail_support.png';
import whatsapp from '../../assets/images/whatsapp.png';
import document from '../../assets/images/document.png';
import image from '../../assets/images/image-gallery.png';
import play from '../../assets/images/play-button-arrowhead.png';
import pause from '../../assets/images/pause.png';
import mike_off from '../../assets/images/mic_off.svg';
import documentuploadicon from "../../assets/images/documentuploadicon.png";
import video from '../../assets/images/youtube.png';
import del from '../../assets/images/del.svg';
import { saveMessages, updateReadMessages, getMessages } from "../../Redux/Api/fetch.api";
import InfiniteScroll from 'react-infinite-scroll-component'; // Import InfiniteScroll
import ThreeDotsLoader from "../ThreeDotsLoader";
import AudioRecorder from '../SupportAttachment/audio';
import WaveSurfer from 'wavesurfer.js';
import UploadImage from '../UploadImages/UplodeImageForSupport';
import { Player } from "video-react";
import "video-react/dist/video-react.css";
import heic2any from 'heic2any';
import { SAVE_CHAT } from '../../api/uri_helper';
import axios from "axios";
import useDownloader from "react-use-downloader";


const ChatBox = ({ content,
    onClose,
    className,
    loginUserName,
    userEmailId,
    loginuserId,
    supportId,
    receiverUserName,
    receiverById,
    responseType,
    readMessageInitial,
    phoneNumber }) => {

    const [errorMessage, setErrorMessage] = useState("");
    const chatContainerRef = useRef(null);  // Ref to the chat container
    const { connection, connected } = useSignalR(); // SignalR connection\\
    const [message, setMessage] = useState('');
    const [sendButtonDisable, setSendButtonDisable] = useState(false)
    const [isChatOpen, setIsChatOpen] = useState(true);
    const [messages, setMessages] = useState(content?.messages || []);
    const [isMinimized, setIsMinimized] = useState(false);
    const isMinimizedRef = useRef(false)
    const [isReadMessage, setIsReadMessage] = useState(null);
    const [isTyping, setIsTyping] = useState(false); // To track typing state
    const [typingUser, setTypingUser] = useState(null);
    const [messageReceived, setMessageReceived] = useState(false);
    const [messageCount, setMessageCount] = useState(0); // Track unread messages count
    const [receiverUserId, setReceiverUserId] = useState('');
    const [messageSender, setMessageSender] = useState(content.requestedBy);
    const messageInputRef = useRef(null);
    const [loading, setLoading] = useState(false); // For infinite scroll loading state
    const [page, setPage] = useState(1); // Page number for fetching previous messages
    const [technicianId, settechnicianId] = useState(loginuserId)
    const [hasMore, setHasMore] = useState(true);
    const senderEmail = userEmailId;
    const receiverEmail = userEmailId !== content?.emailId ? content?.emailId : messageSender;
    const bottomRef = useRef(null);  // Ref to target the bottom of the scroll
    const [expandChat, setExpandChat] = useState(false)
    const [isRecording, setIsRecording] = useState(false)
    let typingTimeout;
    const [unreadMessagesCount, setUnreadMessagesCount] = useState(0);
    const [scrollPosition, setScrollPosition] = useState(0);
    const [attachmentMenuVisible, setAttachmentMenuVisible] = useState(false);
    const [audioUrl, setAudioUrl] = useState(null);
    const waveformRef = useRef(null); // Ref to the WaveSurfer container
    const [allUploadedFiles, setAllUploadedFiles] = useState([]);
    const [isPlaying, setIsPlaying] = useState(false); // State to track if audio is playing
    const wavesurferInstance = useRef(null); // Store the WaveSurfer instance
    const [uploadedImage, setUploadedImage] = useState([]);
    const [isImageUploaded, setImageUploaded] = useState(false)
    const [isLoading, setIsLoading] = useState(false);
    const [uploadedDoc, setUploadedDoc] = useState([]);
    const [pdfMedia, setPdfMedia] = useState("");
    const [fileName, setFileName] = useState("");
    const [docFileName, setDocFileName] = useState([]);
    const inputDocRef = useRef();
    const [heicFile, setHeicFile] = useState(false);
    const [images, setImages] = useState({
        upload: {
            pictures: [],
            maxFileSize: 5242880,
            imgExtension: [".jpg", ".png", ".jpeg"],
            defaultImages: []
        }
    })
    let fileTypeId, fileType;
    const videos = [];
    const inputVideoRef = useRef();
    const [uploadedVideo, setUploadedVideo] = useState([]);
    const { download } = useDownloader();
    const [messageStatus, setmessageStatus] = useState(false);
    const [receivedMessage, setReceivedMessage] = useState(false); 
    useEffect(() => {
        if (loginUserName != receiverUserName) {
            setReceiverUserId(receiverById);
        }
        else {
            setReceiverUserId(technicianId)
        }
    }, [loginUserName, receiverUserName])

    useEffect(() => {
        isMinimizedRef.current = isMinimized;
    }, [isMinimized]);

    useEffect(() => {
        fetchMessages(page); // Initial message load
    }, [page]);

    const fetchMessages = async (pageIndex) => {

        setLoading(true);
        const chatContainer = chatContainerRef.current;

        // Store the current scroll position and the height of the container
        const previousScrollTop = chatContainer.scrollTop;
        const previousContainerHeight = chatContainer.scrollHeight; // Total content height (scrollable content)
        try {
            const payload = { SupportId: supportId, PageSize: 10, Pageindex: pageIndex };
            const response = await getMessages(payload);
            const sortedMessages = response.data.data.sort((a, b) => new Date(a.sentAt) - new Date(b.sentAt));

            const normalizedMessages = sortedMessages.map(msg => ({
                user: msg.senderId !== loginuserId ? receiverUserName : loginUserName,
                message: msg.message,
                isRead: msg.readAt || readMessageInitial ? true : false,
                sentAt: msg.sentAt,
                mediaUrl: msg.mediaUrl,
                senderName: msg.senderName
            }));

            setMessages(prevMessages => [...normalizedMessages, ...prevMessages]);
            setHasMore(response.data.data.length >= payload.PageSize);

            // After fetching new messages, adjust the scroll position
            const newContainerHeight = chatContainer.scrollHeight; // New total content height
            const heightDifference = newContainerHeight - previousContainerHeight;

            // If loading more messages (scrolled up), we adjust scroll position
            if (pageIndex > 1) {
                chatContainer.scrollTop = previousScrollTop + heightDifference;
            } else {
                // For initial load (page 1), scroll to the bottom
                scrollToBottom();
            }
        } catch (err) {
            console.error("Error fetching messages:", err);
        } finally {
            setLoading(false);
        }
    };

    // Get unread messages count
    //  unreadMessagesCount = messages.filter(msg => !msg.isRead && msg.user !== loginUserName ).length;
    // const unreadmessage = messages.filter(msg => !msg.isRead);

    let currentMessageCount = 0;
    useEffect(() => {
        if (!connection) return;
        const handleReceiveMessage = (
            senderUserName,
            receivedMessage,
            senderEmail,
            supportId,
            userId,
            responseType,
            mediaUrl
        ) => {
            setReceivedMessage(true);
        
            try {
                if (page === 1) scrollToBottom();
        
                setMessages(prevMessages => [
                    ...prevMessages,
                    {
                        user: senderUserName ,
                        message: receivedMessage,
                        mediaUrl,
                        isRead: messageStatus
                    }
                ]);
                
                console.log('isMinimized : ', isMinimized)
                console.log('readMessageInitial : ', readMessageInitial)
                console.log('messageReceived : ', messageReceived)
                console.log('isMinimizedRef.current : ', isMinimizedRef.current)
        
                if (isMinimized === false && readMessageInitial === false && messageReceived) {
                    console.log('if block executed')
                    const payload = {
                        SupportId: supportId,
                        ReadByUser: loginuserId
                    };
                    updateReadMessages(payload);
                    setUnreadMessagesCount(0);
                    connection.invoke('ReadMessageStatus', true);

                    setMessages(prevMessages =>
                        prevMessages.map(msg =>
                            msg.user === loginUserName ? { ...msg, isRead: true } : msg
                        )
                    );
                } else if (isMinimized && !readMessageInitial) {
                    console.log('1st else if block executed')
                    setUnreadMessagesCount(prev => prev + 1);
                    setMessageCount(prev => prev + 1);
                    connection.invoke('ReadMessageStatus', false);
                } else if (!isMinimizedRef.current && !readMessageInitial){
                    console.log('2nd else if block executed')
                    setMessageCount(0);
                    connection.invoke('ReadMessageStatus', true);
                }
                else {
                }
                scrollToBottom()
            } catch (error) {
                console.error("Error in handleReceiveMessage:", error);
            } finally {
                setReceivedMessage(false);
            }
        };
        

        const handleUserTyping = (typingUserName, receivedsupportId) => {
            if (
                typingUserName !== loginUserName &&
                supportId === receivedsupportId
            ) {
                const nameParts = typingUserName.split(' ');
                const formattedName = `${nameParts[1]} ${nameParts[0]}`;
                if (content.requestedBy === formattedName) {
                    setTypingUser(`${typingUserName} is typing...`);
                }
            }
        };

        const handleStopTyping = () => {
            setTypingUser(null);
        };

        const handleReadMessageStatus = (isRead) => {
            setIsReadMessage(isRead);
            if (isRead) {
                setMessages(prevMessages =>
                    prevMessages.map(msg =>
                        msg.user === loginUserName ? { ...msg, isRead } : msg
                    )
                );
            }
        };

        connection.on('ReceiveMessage', handleReceiveMessage);
        connection.on('UserTyping', handleUserTyping);
        connection.on('StopTyping', handleStopTyping);
        connection.on('ReadMessageStatus', handleReadMessageStatus);

        if (isMinimized && !readMessageInitial) {
            setMessageReceived(true);
            setUnreadMessagesCount(prev => prev + 1)
            //   unreadMessagesCount += 1;
            setMessageCount(prev => prev + 1);
            connection.invoke('ReadMessageStatus', false);
        }

        return () => {
            console.log("Chat closed");
        };
    }, [connection, messageReceived]);

    useEffect(() => {
        if (!connection) return;

        const markMessagesAsRead = () => {
            const payload = {
                SupportId: supportId,
                ReadByUser: loginuserId
            };

            updateReadMessages(payload);
            setMessageReceived(false);
            //    unreadMessagesCount = 0;
            setUnreadMessagesCount(0)
            setMessages(prevMessages =>
                prevMessages.map(msg =>
                    msg.user !== loginUserName ? ({ ...msg, isRead: true }) : msg)
            );


            connection.invoke('ReadMessageStatus', true);
        };

        if (!isMinimized) {
            markMessagesAsRead();
        } else {
            if (readMessageInitial === true) {
                //   unreadMessagesCount = 0;
                setUnreadMessagesCount(0)
                return;
            }

            connection.invoke('ReadMessageStatus', false);
            scrollToBottom();
        }
    }, [isMinimized, messageReceived, supportId, loginuserId]);

    useEffect(() => {
        
        if (isMinimized && receivedMessage) {
            setMessageCount(prev => prev + 1);
        }
        else 
            if(!isMinimized && messageCount > 0) {
            setMessageCount(0);}
        
    }, [messages])

    const toggleMinimized = async () => {
        setIsMinimized(prev => !prev);

        if (!isMinimized && messageReceived) {
            setExpandChat(false);
            setmessageStatus(true);
            //   unreadMessagesCount = 0;
            setUnreadMessagesCount(0)
            if (chatContainerRef.current) {
                setScrollPosition(chatContainerRef.current.scrollTop);
            }
        } else {
            setmessageStatus(false);
            connection.invoke('ReadMessageStatus', false);
            scrollToBottom();
        }
        setTimeout(()=>{
            scrollToBottom()
        },300)
    };

    // Cleanup old instances when messages change
    useEffect(() => {
        // Cleanup all existing WaveSurfer instances when component unmounts or when messages change
        return () => {
            Object.values(waveSurferInstances.current).forEach((waveSurfer) => {
                waveSurfer.destroy();
            });
            waveSurferInstances.current = {}; // Reset instances
        };
    }, [messages]);

    useEffect(() => {
        // Create or update WaveSurfer instances for all messages
        messages.forEach((msg, index) => {
            if (msg.mediaUrl && msg.mediaUrl.match(/\.(mp3)$/i)) {
                const container = waveformRefs.current[index];
                if (!container) return; // Skip if the container ref is not set

                // Skip creating new instance if it's already created
                if (waveSurferInstances.current[index]) return;

                // Create a new WaveSurfer instance for the new message
                const waveSurfer = WaveSurfer.create({
                    container: container,
                    waveColor: '#aeaba8',
                    progressColor: '#686767',
                    barWidth: 3,
                    barHeight: 5,
                    barGap: 2,
                    hideScrollbar: true,
                    responsive: true,
                    cursorWidth: 2,
                    height: 30,
                });

                waveSurfer.load(msg.mediaUrl);  // Load the specific media URL for this message

                // Event listener for when audio finishes
                waveSurfer.on('finish', () => {
                    setIsPlaying(false);
                    setCurrentPlayingIndex(null); // Reset the playing index when it finishes
                });

                // Store the WaveSurfer instance with the index as the key
                waveSurferInstances.current[index] = waveSurfer;
            }
        });
    }, [messages]); // Ensure this effect runs when messages change

    // Function to scroll to the bottom
    const scrollToBottom = () => {
        const chatContainer = chatContainerRef.current;
        if (chatContainer) {
            chatContainer.scrollTop = chatContainer.scrollHeight; // Scroll to the bottom of the container
        }
    };

    // Function to handle the recorded audio URL
    const handleAudioRecorded = async (url) => {
        setAudioUrl(url); // Update the audio URL state

        try {
            // Fetch the audio file from the URL (convert it to a Blob)
            const response = await fetch(url);
            const blob = await response.blob(); // Convert the response to a Blob
            const timestamp = new Date().toISOString().replace(/[^\w\s]/gi, '-');

            // Determine the audio file extension (can be dynamic if needed)
            const audioFileExtension = '.mp3';
            const recordedFileName = `audio_recording_${timestamp}${audioFileExtension}`;


            // Create a file from the Blob with a name and type
            const audioFile = new File([blob], recordedFileName, { type: 'audio/mp3' });

            // Check if there's already an audio file in the allUploadedFiles array
            const existingAudioIndex = allUploadedFiles.findIndex(file => file.FileTypeId === 4);

            if (existingAudioIndex !== -1) {
                // If an audio file exists, replace it with the new one
                allUploadedFiles[existingAudioIndex] = {
                    AttachmentFile: audioFile,
                    FileTypeId: 4, // Assuming 4 is for audio files
                    Extension: audioFileExtension
                };
            } else {
                // If no audio file exists, add the new one to the array
                allUploadedFiles.push({
                    AttachmentFile: audioFile,
                    FileTypeId: 4, // Assuming 4 is for audio files
                    Extension: audioFileExtension
                });
            }

            // Update the state with the new allUploadedFiles array
            setAllUploadedFiles([...allUploadedFiles]);

            // Call sendMessage to send the audio after it's been added to the array
            sendMessage();
        } catch (error) {
            console.error("Error fetching audio blob:", error);
        }
    };

    const [currentPlayingIndex, setCurrentPlayingIndex] = useState(null);

    const waveformRefs = useRef([]); // To store waveform containers
    const waveSurferInstances = useRef({}); // To store WaveSurfer instances



    const handlePlayPause = (index) => {
        const waveSurfer = waveSurferInstances.current[index];
        if (isPlaying) {
            waveSurfer.pause();
        } else {
            waveSurfer.play();
        }
        setIsPlaying(!isPlaying);
        setCurrentPlayingIndex(isPlaying ? null : index);
    };

    // Handle send message
    const sendMessage_OLD = async () => {
        if (message.trim()) {
            try {
                setSendButtonDisable(true);
                const targetEmail = senderEmail !== content.emailId ? receiverEmail : messageSender;
                const currentTimeUTC = new Date().toISOString(); // This gives you the time in ISO format (UTC)
                const payload = {
                    senderId: loginuserId, receiverId: receiverUserId, messageType: 0, message, supportId,
                    sentAt: currentTimeUTC,// Add the current UTC time to the payload
                    RequestType: responseType,
                    ToPhoneNumber: phoneNumber && phoneNumber,
                    SenderName: loginUserName
                };

                if (connection && connection.state === "Connected") {
                    await saveMessages(payload); // Save message to DB
                    await connection.invoke('SendChatMessage', targetEmail, message, supportId, loginuserId);
                    setMessages(prevMessages => [...prevMessages, { user: loginUserName, message, isRead: (isReadMessage === false || isReadMessage === null) ? false : true }]);
                    setMessage(''); // Clear message input field
                    scrollToBottom();
                } else {
                    console.error('SignalR connection is not established');
                }

            } catch (error) {
                console.error('Error sending message:', error);
            }
            finally {
                setSendButtonDisable(false)
            }
        }
    };

    const sendMessage = async () => {
        //if (message.trim()) {
        try {
            debugger;
            setSendButtonDisable(true);
            const formData = new FormData();
            const uploadedFileNames = new Set();
            const targetEmail = senderEmail !== content.emailId ? receiverEmail : messageSender;
            const currentTimeUTC = new Date().toISOString(); // This gives you the time in ISO format (UTC)

            allUploadedFiles && allUploadedFiles.forEach((fileObj, index) => {
                if (fileObj.Extension === '.heic') {

                    const _fileData = new File([fileObj.AttachmentFile], fileObj.AttachmentFile.name);
                    if (!uploadedFileNames.has(_fileData.name)) {
                        //   setImageName(_fileData.name);
                        formData.append(`SupportAttachments[${index}].AttachmentFile`, _fileData);
                        formData.append(`SupportAttachments[${index}].FileTypeId`, fileObj.FileTypeId);
                        uploadedFileNames.add(_fileData.name);
                    }
                    setHeicFile(false);
                }

                else if (fileObj.Extension === '.jpg' || fileObj.Extension === '.jpeg' || fileObj.Extension === '.png' || fileObj.Extension === '.gif' || fileObj.Extension === '.svg') {

                    const imageUrl = fileObj.AttachmentFile.split(";");
                    var contentType = imageUrl[0].split(":")[1];
                    var realData = imageUrl[2].split(",")[1];
                    var blob = b64toBlob(realData, contentType);
                    const _fileData = new File([blob], imageUrl[1].substring(5));
                    if (!uploadedFileNames.has(_fileData.name)) {
                        //   setImageName(_fileData.name);
                        formData.append(`SupportAttachments[${index}].AttachmentFile`, _fileData);
                        formData.append(`SupportAttachments[${index}].FileTypeId`, fileObj.FileTypeId);
                        uploadedFileNames.add(_fileData.name);
                    }
                }

                else if (fileObj.Extension === '.mp4' || fileObj.Extension === '.MOV' || fileObj.Extension === '.mov' || fileObj.Extension === '.wmv' || fileObj.Extension === '.avi') {
                    const videoData = new File([new Blob([fileObj.AttachmentFile])], fileObj.name);
                    if (!uploadedFileNames.has(videoData.name)) {
                        formData.append(`SupportAttachments[${index}].AttachmentFile`, videoData);
                        formData.append(`SupportAttachments[${index}].FileTypeId`, fileObj.FileTypeId);
                        uploadedFileNames.add(videoData.name);
                    }
                }

                else if (['.pdf', '.csv', '.doc', '.docx', '.xls', '.xlsx'].includes(fileObj.Extension.toLowerCase())) {
                    const pdfBlob = new Blob([fileObj.pdfFile]);
                    const pdfData = new File([pdfBlob], fileObj.AttachmentFile);
                    if (!uploadedFileNames.has(pdfData.name)) {
                        formData.append(`SupportAttachments[${index}].AttachmentFile`, pdfData);
                        formData.append(`SupportAttachments[${index}].FileTypeId`, fileObj.FileTypeId);
                        uploadedFileNames.add(pdfData.name);
                    }
                }

                else if (fileObj.Extension === '.mp3' || fileObj.Extension === '.webm') {
                    const { AttachmentFile, FileTypeId, Extension } = fileObj;

                    if (!uploadedFileNames.has(AttachmentFile.name)) {
                        formData.append(`SupportAttachments[${index}].AttachmentFile`, AttachmentFile);
                        formData.append(`SupportAttachments[${index}].FileTypeId`, FileTypeId);
                        uploadedFileNames.add(AttachmentFile.name);
                    }
                } else {
                    console.log('no file uploaded');
                }
            });

            formData.append("senderId", loginuserId);
            formData.append("receiverId", receiverUserId);
            formData.append("messageType", 0);
            formData.append("message", message ?? "");
            formData.append("supportId", supportId)
            formData.append("sentAt", currentTimeUTC);
            formData.append("RequestType", responseType);
            formData.append("ToPhoneNumber", phoneNumber ? phoneNumber : null);
            formData.append("SenderName", loginUserName);

            if (connection && connection.state === "Connected") {
                //  const response = await saveMessages(formData);
                const response = await axios.post(SAVE_CHAT, formData);
                if (response.data.success) {

                    const mediaUrlUploaded = response.data && response.data.data;

                    await connection.invoke('SendChatMessage', targetEmail, message, supportId, loginuserId, responseType, mediaUrlUploaded);
                    setMessages(prevMessages => [
                        ...prevMessages,
                        {
                            user: loginUserName,
                            message: message ?? "",
                            mediaUrl: mediaUrlUploaded,
                            isRead: (isReadMessage === false || isReadMessage === null) ? false : true
                        }
                    ]);

                    setAllUploadedFiles([]);
                    setUploadedImage([]);
                    setUploadedDoc([]);
                    setUploadedVideo([]);
                    setMessage(''); // Clear message input field
                    scrollToBottom();
                }
                else {
                    console.error('SignalR connection is not established');
                }
            } else {
                console.error('SignalR connection is not established');
            }

        } catch (error) {
            console.error('Error sending message:', error);
        }
        finally {
            setSendButtonDisable(false)
        }
        //}
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter' && !e.shiftKey && !sendButtonDisable) {
            e.preventDefault();
            if (!message?.trim() && allUploadedFiles.length === 0 && audioUrl === null) {
                return
            }
            sendMessage();
        }
    };

    const handleTyping = () => {
        if (!isTyping) {
            setIsTyping(true);
            if (connection?.state === "Connected") {
                connection.invoke('NotifyUserTyping', loginUserName, supportId); // Notify other side
            }
        }

        clearTimeout(typingTimeout);
        typingTimeout = setTimeout(() => {
            setIsTyping(false);
            if (connection?.state === "Connected") {
                connection.invoke('StopUserTyping', loginUserName, supportId); // Stop typing notification
            }
        }, 1500);
    };

    const handleScroll = () => {
        const chatContainer = chatContainerRef.current;
        if (chatContainer.scrollTop === 0 && !loading) {
            setPage(prevPage => prevPage + 1); // Load previous messages when scrolled to the top
        }
    };

    const handleClose = () => {
        connection.invoke('ReadMessageStatus', true);
        onClose();

    }

    const handleExpand = () => {
        setExpandChat(prev => !prev);
    }

    useEffect(() => {
        if (!isMinimized && chatContainerRef.current) {

            // Restore the scroll position when reopened
            chatContainerRef.current.scrollTop = scrollPosition;
            if (readMessageInitial === true) {
                connection.invoke('ReadMessageStatus', true);
            }
        }
    }, [isMinimized, scrollPosition]); // Runs when the chatbox is reopened (not minimized)

    const formatTimeAgo = (sentAt) => {
        const now = new Date();
        const messageTime = sentAt ? new Date(sentAt) : now;
        const secondsAgo = Math.floor((now - messageTime) / 1000);

        if (secondsAgo < 60) return 'just now';
        const minutesAgo = Math.floor(secondsAgo / 60);
        if (minutesAgo < 60) return `${minutesAgo} min${minutesAgo > 1 ? 's' : ''} ago`;
        const hoursAgo = Math.floor(minutesAgo / 60);
        if (hoursAgo < 24) return `${hoursAgo} hr${hoursAgo > 1 ? 's' : ''} ago`;
        const daysAgo = Math.floor(hoursAgo / 24);
        if (daysAgo < 30) return `${daysAgo} day${daysAgo > 1 ? 's' : ''} ago`;
        const monthsAgo = Math.floor(daysAgo / 30);
        if (monthsAgo < 12) return `${monthsAgo} month${monthsAgo > 1 ? 's' : ''} ago`;
        const yearsAgo = Math.floor(monthsAgo / 12);
        return `${yearsAgo} year${yearsAgo > 1 ? 's' : ''} ago`;
    };

    const handleImage = () => {
        setImageUploaded(true);
    }

    function base64ToBinary(base64) {
        const binaryString = atob(base64);
        const length = binaryString.length;
        const bytes = new Uint8Array(length);
        for (let i = 0; i < length; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }
        return bytes;
    }

    function b64toBlob(b64Data, contentType, sliceSize) {
        contentType = contentType || '';
        sliceSize = sliceSize || 512;
        var byteCharacters = atob(b64Data);
        var byteArrays = [];
        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            var slice = byteCharacters.slice(offset, offset + sliceSize);
            var byteNumbers = new Array(slice.length);
            for (var i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            var byteArray = new Uint8Array(byteNumbers);

            byteArrays.push(byteArray);
        }
        var blob = new Blob(byteArrays, { type: contentType });
        return blob;
    }

    function calculateImageSize(base64) {
        const binaryData = base64ToBinary(base64);
        const fileSizeInBytes = binaryData.length;
        const fileSizeInKB = fileSizeInBytes / 1024; // Convert bytes to kilobytes
        const fileSizeInMB = fileSizeInKB / 1024; // Convert kilobytes to megabytes

        return {
            bytes: fileSizeInBytes,
            kilobytes: fileSizeInKB,
            megabytes: fileSizeInMB
        };
    }

    const handleImagesChange = async (files) => {

        setAttachmentMenuVisible(false)
        const uploadedFilesWithExtensions = [];
        let newUrl, newBlob;
        if (!files || files.length === 0) {
            //   setAttacmentOptionsDisplay(false);
            setErrorMessage("SelectonlyImage");
            setTimeout(() => {
                setErrorMessage('');
            }, 5000);
            return;
        }
        let extension = '';
        for (let i = 0; i < files.length; i++) {
            const file = files[i];


            if (file.type && file.type.startsWith('image/')) {
                extension = '.' + file.type.split('/')[1];
            } else if (file.name) {
                const filename = file.name;
                const match = filename.match(/\.([^.]+)$/);
                if (match && match.length > 1) {
                    extension = '.' + match[1].toLowerCase();
                }
            }

            // Check if it's a data URI
            const dataUriIndex = file.indexOf('data:');
            if (dataUriIndex === 0) {
                const nameIndex = file.indexOf('name=', dataUriIndex);
                if (nameIndex > -1) {
                    const semicolonIndex = file.indexOf(';', nameIndex);
                    if (semicolonIndex > -1) {
                        const nameSubstring = file.substring(nameIndex, semicolonIndex);
                        const dotIndex = nameSubstring.lastIndexOf('.');
                        if (dotIndex > -1) {
                            extension = nameSubstring.substring(dotIndex);
                        }
                    }
                }
            }

            const base64String = file.split(';base64,')[1];
            const size = calculateImageSize(base64String);
            const allowedExtensions = ['.jpg', '.jpeg', '.svg', '.png', '.gif', 'heic'];

            if (size.megabytes > 10) {
                ///  setImages('');
                //    setAttacmentOptionsDisplay(false);
                setErrorMessage("Image size exceeds");
                setImages('');
                setTimeout(() => {
                    setErrorMessage('');
                }, 5000);
                return;
            }
            else {
                if (extension === '.heic') {
                    setIsLoading(true);
                    const semicolonIndex = file.indexOf(';');
                    try {
                        if (semicolonIndex !== -1) {
                            const response = await fetch(file);
                            const blob = await response.blob();
                            const conversionResult = await heic2any({ blob });
                            const url = URL.createObjectURL(conversionResult);
                            const filename = file.split(';')[1].split('=')[1];
                            const newFilename = filename.replace('.heic', '.jpeg');
                            newBlob = new Blob([conversionResult], { type: 'image/jpeg' });
                            newBlob.name = newFilename;
                            newUrl = URL.createObjectURL(newBlob);
                            if (!images.upload.pictures.includes(filename)) {
                                //  if (!images.includes(filename)) {
                                //  if (!uploadedFileHeic.includes(filename)) {
                                setHeicFile(true);
                                //   setUploadedImage(prevImages => [...prevImages, newUrl]);
                                setUploadedImage(newUrl);
                                setImages({
                                    ...images,
                                    upload: {
                                        ...images.upload,
                                        pictures: [...images.upload.pictures, newBlob],
                                    },
                                });


                                //  setUploadedFileHeic(prevFileHeic => [...prevFileHeic, filename]);
                            } else {
                                // Handle the case when the filename already exists

                                setErrorMessage("Filealreadyuploaded", filename);
                                setTimeout(() => {
                                    setErrorMessage('');
                                }, 5000);
                                return;
                            }
                            //  setUploadedImage(newUrl)
                        }
                    } catch (error) {
                        console.log(error);
                    } finally {
                        setIsLoading(false);
                    }
                }

                else {
                    const blob = file;
                    if (uploadedImage && !uploadedImage.includes(blob)) {
                        //  setUploadedImage(prevImages => [...prevImages, blob]);
                        setUploadedImage(blob);
                        setImages({
                            ...images,
                            upload: {
                                ...images.upload,
                                pictures: [...images.upload.pictures, blob],
                            },
                        });
                        //   setUploadedImage(blob)
                    }
                }
            }

            if (extension !== '.heic') {
                if (allUploadedFiles && !allUploadedFiles.some(existingFile => existingFile.AttachmentFile === file)) {
                    const fileType = handleFileType(extension);
                    uploadedFilesWithExtensions.push({ AttachmentFile: file, FileTypeId: fileType, Extension: extension });
                }
            }
            else {
                if (allUploadedFiles && !allUploadedFiles.some(existingFile => existingFile.AttachmentFile === newBlob)) {
                    extension = '.heic';
                    const fileType = handleFileType(extension);
                    uploadedFilesWithExtensions.push({ AttachmentFile: newBlob, FileTypeId: fileType, Extension: extension });
                }
            }
        }

        setUploadedVideo('');
        setUploadedDoc('');
        setAllUploadedFiles(prevFiles => [...prevFiles, ...uploadedFilesWithExtensions]);

    };

    const handleFileType = (fileTypeExtension) => {
        if (fileTypeExtension === '.jpg' || fileTypeExtension === '.jpeg' || fileTypeExtension === '.png' || fileTypeExtension === '.gif' || fileTypeExtension === '.svg' || fileTypeExtension === '.heic') {
            fileTypeId = 1
        }
        else if (fileTypeExtension === '.mp4' || fileTypeExtension === '.MOV' || fileTypeExtension === '.mov' || fileTypeExtension === '.wmv' || fileTypeExtension === '.avi') {
            fileTypeId = 2
        }
        else if (fileTypeExtension === '.pdf' || fileTypeExtension === '.doc' || fileTypeExtension === '.docx' || fileTypeExtension === '.CSV' || fileTypeExtension === '.xlsx' || fileTypeExtension === '.xls') {
            fileTypeId = 3
        }
        else if (fileTypeExtension === '.mp3' || fileTypeExtension === '.webm' || fileTypeExtension === '.wav') {
            fileTypeId = 4
        }
        else {
        }
        return fileTypeId
    }

    // Toggle visibility of attachment menu
    const handleAttachment = () => {
        setAttachmentMenuVisible(prev => !prev);
    }

    const handleDocChoose = (event) => {
        //  setAttacmentOptionsDisplay(false);
        inputDocRef.current.click();
    };

    const handleDocFileChange = (event) => {

        setAttachmentMenuVisible(false);
        setAllUploadedFiles([]);
        const duplicateFiles = [];

        const files = event.target.files;
        const maxSize = 5 * 1024 * 1024;

        const uploadedDocumentsWithExtensions = [];
        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            if (file.size <= maxSize) {
                // if (file.type === 'application/pdf') {
                setErrorMessage('');

                const fileExtension = '.' + file.name.split('.').pop();
                fileType = handleFileType(fileExtension);
                //   fileType = ;
                const url = URL.createObjectURL(file);
                setFileName(file.name);
                setDocFileName(file.Name);
                setPdfMedia(file);

                // Push the file itself into the array
                uploadedDocumentsWithExtensions.push({
                    AttachmentFile: file.name,
                    FileTypeId: fileType,
                    Extension: fileExtension,
                    pdfFile: file
                });

            } else {
                // Reset the input value if file size exceeds 5 MB
                inputDocRef.current.value = '';
                setErrorMessage('File size should be max 5mb');
                setTimeout(() => {
                    setErrorMessage('');
                }, 3000);
            }
        }

        const newDocsToAdd = uploadedDocumentsWithExtensions.filter((doc) => {
            for (const existingDoc of uploadedDoc) {
                if (existingDoc.AttachmentFile === doc.AttachmentFile) {
                    duplicateFiles.push(doc.AttachmentFile);
                    return false;
                }
            }
            return true;
        });

        // Display error message for duplicates
        if (duplicateFiles.length > 0) {
            setErrorMessage(`Uploaded file(s) already exist: ${duplicateFiles.join(', ')}`);
            setTimeout(() => {
                setErrorMessage('');
            }, 3000);
        }

        setUploadedDoc(newDocsToAdd);
        setUploadedVideo('');
        setUploadedImage('');
        setAllUploadedFiles(newDocsToAdd);
    };

    const handleVideoFileChange = (event) => {
        setAttachmentMenuVisible(false);
        const files = event.target.files;
        setAllUploadedFiles([]);
        for (let i = 0; i < files.length; i++) {
            const file = files[i];

            // Check file size
            const fileSizeInBytes = file.size;
            const fileSizeInMB = fileSizeInBytes / (1024 * 1024);

            // If file size exceeds 50MB, show error message and return
            if (fileSizeInMB > 10) {
                setErrorMessage("Video file size should be max 10mb");
                setTimeout(() => {
                    setErrorMessage('');
                }, 3000);
                setAttachmentMenuVisible(false);
                return;
            }
            // Add file to the videos array
            videos.push(file);
        }

        const uploadedVideoFilesWithExtensions = videos.map(videoFile => {
            const fileExtension = '.' + videoFile.name.split('.').pop();
            fileType = handleFileType(fileExtension);
            const urlForVideo = URL.createObjectURL(videoFile);
            setAttachmentMenuVisible(false);
            return {
                AttachmentFile: videoFile, name: videoFile.name, url: urlForVideo,
                FileTypeId: fileType, Extension: fileExtension
            };
        });

        const newVideosToAdd = uploadedVideoFilesWithExtensions.filter(video => {
            for (const existingVideo of uploadedVideo) {
                if (existingVideo.name === video.name) {
                    setAttachmentMenuVisible(false);
                    return false;
                }
            }
            setAttachmentMenuVisible(false);
            return true;
        });

        setUploadedVideo(newVideosToAdd);
        setUploadedDoc('');
        setUploadedImage('');
        setAllUploadedFiles(newVideosToAdd);
    };

    const handleVideoChoose = (event) => {
        inputVideoRef.current && inputVideoRef.current.click();
    };

    const handleAudio = () => {
        setAllUploadedFiles([]);
        setIsRecording(prev => !prev)
    }

    const handleDeleteMedia = () => {
        setAllUploadedFiles([]);
        setUploadedImage([]);
        setUploadedVideo([]);
        setUploadedDoc([]);
    }

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedImage, setSelectedImage] = useState('');
    const [contextMenu, setContextMenu] = useState({ visible: false, x: 0, y: 0 });

    const handleImageClick = (url) => {
        setSelectedImage(url); // Set the selected image URL
        setIsModalOpen(true);   // Open the modal
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);  // Close the modal
        setSelectedImage('');   // Clear the selected image
    };

    // Right-click (context menu) handler for images
    const handleContextMenu = (e, url) => {
        e.preventDefault(); // Prevent the default right-click menu

        // Set the position of the custom context menu
        setContextMenu({
            visible: true,
            x: e.clientX,
            y: e.clientY,
        });

        // Store the selected image URL to download it later
        setSelectedImage(url);
    };

    // Handle image download
    const handleDownloadImage = () => {
        if (!selectedImage) return; // Ensure the image exists before attempting to download

        // Create a temporary link to trigger the download
        const link = document.createElement('a');
        link.href = selectedImage;
        link.download = selectedImage.split('/').pop(); // Name the file from the URL
        link.click();
        setContextMenu({ ...contextMenu, visible: false }); // Close context menu after download
    };

    // Close the context menu
    const closeContextMenu = () => {
        setContextMenu({ ...contextMenu, visible: false }); // Close the context menu
    };

    return (
        <div className={`support-chat-box ${className || "chatbox-enter"} ${isMinimized ? 'minimized' : 'maximize'} ${!isMinimized && expandChat ? 'expand-chat' : ''}`}>

            <div className="chatbox-header">
                <div className="chat-name">
                    {/* <div className="chat-header-avatar">{getInitials(content?.requestedBy || "Unknown")}</div> */}
                    <div className='statusICon'>
                        {responseType === 0 && (
                            <img src={chat} alt="Live Chat" title="Live Chat" />
                        )}
                        {responseType === 1 && (
                            <img src={mike} alt="Audio" title="Audio Call" />
                        )}
                        {responseType === 2 && (
                            <img src={video} alt="Video" title="Video Call" />
                        )}
                        {responseType === 3 && (
                            <img src={email} alt="Email" title="Email" />
                        )}
                        {responseType === 4 && (
                            <img src={whatsapp} alt="WhatsApp" title="WhatsApp" />
                        )}
                        {responseType === 5 && (
                            <img src={sms} alt="SMS" title="SMS" />
                        )}
                    </div>
                    <div className="chat-name-inner">
                        <h4>{content?.requestedBy || "Unknown"}</h4>
                    </div>

                </div>
                <div className="chat-btns">
                    {isMinimized && (
                        <button onClick={toggleMinimized} className="chat-btn-inner">
                            <img src={notification} alt="" />

                            {messageCount > 0 && <div className="messagenotification">{messageCount}</div>}
                        </button>
                    )}

                    <button onClick={toggleMinimized} className="chat-btn-inner">
                        <img src={isMinimized ? MaximiseIcon : MinimizeIcon} alt="Minimize" />
                    </button>

                    {isMinimized ? '' :
                        <button className="chat-btn-inner"
                            onClick={handleExpand}>
                            <img src={expandChat ? collapse_chat : expand} alt="Minimize" />
                        </button>}

                    <button onClick={handleClose} className="chat-btn-inner">
                        <img src={CloseIcon} alt="Close" />
                    </button>

                </div>
            </div>

            {!isMinimized && isChatOpen && (
                <>
                    <div id="chat-inner" ref={chatContainerRef} style={{ overflow: "auto" }} onScroll={handleScroll}>
                        <div className="chat-inner">
                            {loading ? <ThreeDotsLoader /> : ''}

                            {messages.map((msg, index) => (
                                <div key={index} className={msg.user !== loginUserName ? "chat-user" : "chat-user-odd"}>
                                    <div className="chatInner" onClick={closeContextMenu}>

                                        {msg.user !== loginUserName && (
                                            <strong className="chatUser">
                                               {msg.senderName || (msg.user === 'Unknown Sender' ? receiverUserName : msg.user)
        }
                                            </strong>
                                        )}

                                        {msg.mediaUrl && (
                                            <>
                                                {/* Check if the media is an image */}
                                                {msg.mediaUrl.match(/\.(jpeg|jpg|gif|png|svg)$/i) && (
                                                    <img src={msg.mediaUrl} alt="mediaUrl" className="chatImage"
                                                        onClick={() => handleImageClick(msg.mediaUrl)}
                                                    //  onContextMenu={(e) => handleContextMenu(e, msg.mediaUrl)}
                                                    />
                                                )}

                                                {/* Check if the media is a video */}
                                                {msg.mediaUrl.match(/\.(mp4|webm|ogg)$/i) && (
                                                    <div className='media-bubble'>
                                                        <Player
                                                            className="w-100 h-100"
                                                            playsInline
                                                            src={msg.mediaUrl}
                                                            fluid={false}
                                                        /></div>
                                                )}

                                                {/* Check if the media is a document (e.g., PDF) */}
                                                {msg.mediaUrl.match(/\.(pdf|csv|docx?|xlsx?)$/i) && (
                                                    <div className="text-left media-pdf-custom">
                                                        <img
                                                            className="botdoc-upload mb-0"
                                                            src={documentuploadicon} // Provide a PDF icon or your custom document icon
                                                            alt="Document"
                                                            width={40}
                                                            height={40}
                                                            onClick={() => download(msg.mediaUrl, msg.mediaUrl.split('/').pop())}
                                                            title="Click to download"
                                                        />
                                                        <p className='mb-0'>{msg.mediaUrl.split('/').pop()}</p>
                                                    </div>
                                                )}


                                                {msg.mediaUrl.match(/\.(mp3)$/i) && (
                                                    <div className="waveform-container" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '50px' }}>
                                                        <button className="btn-gray" onClick={() => handlePlayPause(index)}>
                                                            <img src={isPlaying && currentPlayingIndex === index ? pause : play} alt="Play/Pause" />
                                                        </button>
                                                        <div
                                                            ref={(el) => waveformRefs.current[index] = el} // Correctly reference each waveform container
                                                            style={{ width: '100%', height: '30px', position: 'relative' }}
                                                        ></div>
                                                    </div>
                                                )}
                                            </>
                                        )}



                                        <span className="chatMessage">{msg.message}</span>
                                        <span className={msg.isRead ? 'seenmessage' : 'unseenmessage'}>
                                            {formatTimeAgo(msg.sentAt)}  {/* Display formatted time */}

                                            {msg.user === loginUserName && messages.length > 0 && (
                                                <img
                                                    src={msg.isRead === true ? checkfill : (isReadMessage === false ? check : checkfill)}
                                                    alt="status"
                                                />
                                            )}
                                        </span>
                                    </div>
                                </div>
                            ))}
                            <div ref={bottomRef} />
                        </div>
                    </div>

                    {typingUser && <div className="typing-indicator">{typingUser}</div>}

                    {allUploadedFiles && allUploadedFiles.length > 0 ?
                        <div class="multiple-media d-flex gap-2" id="custom-scroll">
                            {uploadedImage && uploadedImage.length > 0 && (
                                <div class="media-preview">
                                    <button onClick={handleDeleteMedia}><img class="" src={del} alt="Delete" /></button>
                                    <img src={uploadedImage} alt="Uploaded" />

                                </div>
                            )}

                            {uploadedVideo && uploadedVideo.length > 0 && (
                                <div className="media-preview video-display">
                                    <button onClick={handleDeleteMedia}><img class="" src={del} alt="Delete" /></button>
                                    <Player
                                        className="w-100 h-100"
                                        playsInline
                                        src={uploadedVideo[0].url}  // Ensure the correct URL is passed
                                        fluid={false}
                                    />
                                </div>
                            )}

                            {uploadedDoc && uploadedDoc.length > 0 && (
                                <div className="media-preview">
                                    <button onClick={handleDeleteMedia}><img class="" src={del} alt="Delete" /></button>
                                    <div className="text-center">
                                        <img
                                            className="botdoc-upload mb-3"
                                            src={documentuploadicon}
                                            alt="Document"
                                            width={40}
                                            height={40}
                                        />
                                        <p>{uploadedDoc[0].AttachmentFile ? uploadedDoc[0].AttachmentFile : ""}</p>
                                    </div>
                                </div>
                            )}
                        </div> : ''}

                    <div className='support-chat'>
                        {errorMessage ? <p>{errorMessage}</p> : ''}</div>

                    <div className="chat-footer">
                        {/* <button className='btn-gray'><img className='mikeicon' src={mike} alt='' /></button> */}
                        <button className='btn-gray' onClick={handleAudio}
                            disabled={responseType === 4} ><img className='mikeicon' src={isRecording ? mike_off : mike} alt='' /></button>
                        <button className='btn-gray' onClick={handleAttachment}
                            disabled={sendButtonDisable || responseType === 4}
                        ><img src={attachment} alt='' /></button>


                        <AudioRecorder
                            isRecording={isRecording}
                            setIsRecording={setIsRecording}
                            setAudioUrl={setAudioUrl}
                            handleAudioRecorded={handleAudioRecorded}
                        />

                        {/* <button className='btn-gray' onClick={handleAttachment}><img src={attachment} alt='' /></button> */}

                        {attachmentMenuVisible && (
                            <ul className="attachment-options">

                                <li onClick={handleImage}><img className='attachment-class' src={image} alt='' />
                                    <UploadImage
                                        defaultImages={[]}
                                        pictures={[]}
                                        handleChange={handleImagesChange}
                                        buttonText={responseType === 5 ? 'Image(.jpeg)' : "Image"}
                                        images={false}
                                        accept="image/*"

                                    />
                                </li>

                                <li onClick={handleVideoChoose} className="cursor-pointer">
                                    <input
                                        ref={inputVideoRef}
                                        key={inputVideoRef.current?.value}
                                        type="file"
                                        onChange={handleVideoFileChange}
                                        accept=".mov,.mp4,.wmv,.avi,.MOV"
                                        hidden={true}
                                        multiple
                                    />
                                    <img src={video} alt="Video" />
                                    Video
                                </li>

                                <li onClick={handleDocChoose} className="cursor-pointer">
                                    <input
                                        key={inputDocRef.current?.value}
                                        ref={inputDocRef}
                                        type="file"
                                        onChange={handleDocFileChange}
                                        hidden={true}
                                        multiple
                                        accept=".csv, .xlsx, .xls, .pdf, .doc, .docx"
                                    />
                                    <img src={document} alt="Document" />
                                    Document

                                </li>
                            </ul>
                        )}

                        <textarea className='chatbox-textarea'
                            ref={messageInputRef}
                            placeholder="Please write the message"
                            value={message}
                            disabled={sendButtonDisable}
                            onChange={(e) => setMessage(e.target.value)}
                            onKeyDown={handleKeyPress}
                            onInput={handleTyping}
                            rows={1}
                            maxLength={200}
                        />

                        <button onClick={sendMessage}
                            disabled={sendButtonDisable || (!message?.trim() && allUploadedFiles.length === 0 && !audioUrl)}
                            className="chat-submit-btn">
                            {sendButtonDisable ? (
                                <div className="loader-send-button"></div> // Add your loader here
                            ) : (
                                <img className="send-img" src={Send} alt="Send" />
                            )}
                        </button>
                    </div>

                    {isModalOpen && (
                        <div className="chatbox-modal" onClick={handleCloseModal}>
                            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                                <span className="close" onClick={handleCloseModal}>&times;</span>
                                <img src={selectedImage} alt="Preview" className="modal-image"
                                //  onContextMenu={(e) => handleContextMenu(e, selectedImage)} 
                                />
                            </div>
                        </div>
                    )}

                    {/* {contextMenu.visible && (
                        <div
                            className="context-menu"
                            style={{ top: "256px", left: "156px" }}
                        >
                            <ul>
                                <li onClick={handleDownloadImage}>Download</li>
                            </ul>
                        </div>
                    )} */}
                </>
            )}
        </div>
    );
};

export default ChatBox;